class Adventure {
  currentLevel;

  constructor(world, stage) {
    this.world = world;
    this.visitedLevels = new Map();
    this.log = [];
    this.quests = new Map();
  }

  appendLog(message) {
    this.log.unshift(message);
  }

  startLevel() {
    return this.world.spawnStartLevel();
  }

  spawnLevel(id) {
    return this.world.spawnLevel(id);
  }

  hasVisited(id) {
    return this.visitedLevels.has(id);
  }

  saveLevel(id, snapshot) {
    this.visitedLevels.set(id, snapshot);
  }

  restoreLevel(id) {
    return this.visitedLevels.get(id);
  }

  getLevel(id) {
    return this.world.getLevel(id);
  }

  startQuest(id) {
    this.quests.set(id, 1);
  }

  completeQuest(id) {
    this.quests.set(id, 2);
  }

  cancelQuest(id) {
    this.quests.delete(id);
  }

  hasQuest(id) {
    return this.quests.has(id);
  }

  hasStartedQuest(id) {
    return this.quests.has(id) ? this.quests.get(id) == 1 : false;
  }

  hasCompletedQuest(id) {
    return this.quests.has(id) ? this.quests.get(id) == 2 : false;
  }
}

export default Adventure;
